<template>

    <m-edit1/>

    <m-single-product-201 v-bind='{...{"productLink":null,"relatedProducts":true,"productCardName":"mProductCard207_price","relatedCourse":false,"galleryFullSlider":false,"productAuthor":false,"showSpecifiedFeature":"","showVariationProductImage":false,"mapFeatureName":null,"variationProductComponent":"VariationProduct"},...{}}' :style='""' class="my-3 container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="my-2 shadow bg-secondary container py-3 rounded col-12 text-center text-dark row" >
                <template #default>   <m-h5 v-bind='{...{},...{}}' :style='""' class="col-6 text-left mt-2" >
                <template #default>کاتالوگ محصولات    </template>
                </m-h5><m-modal-501 v-bind='{...{"modalButtonText":"\u0645\u0634\u0627\u0647\u062f\u0647","isVisible":true,"customModalId":null,"closeModalFromUser":true},...{}}' :style='""' class="col-6 text-right" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container text-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto justify-content-center my-5 text-white " >
                <template #default>   <m-h5 v-bind='{...{},...{}}' :style='""' class="col-12 text-dark my-5 " >
                <template #default>برای دریافت کاتالوگ روی کارت های زیر کلیک کنید .   </template>
                </m-h5><m-div v-bind='{...{},...{}}' :style='""' class="content-card-wrapper-almas" >
                <template #default>   <m-a v-bind='{...{"href":"{\"name\":\"mhafez32\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"border-radius:15px;\ntransition: all 0.2s ease-in-out;\nbackground:#f7edff"' class="col-12 text-center p-3 shadow card-header" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.teslaelectric.ir\/storage\/products\/ai19MJh3M35C3qTA7phlqd6zFURKRnJMgFY0WBuD.jpg","alt":""},...{}}' :style='"border-radius:15px;\naspect-ratio:1\/1;\nobject-fit:contain;\nheight:100px\n"' class="img-fluid  mb-4" ></m-img><m-h4 v-bind='{...{},...{}}' :style='"\n\n"' class="text-primary h6" >
                <template #default>محافظ ولتاژ TSE مدل تسلا سری TVP-32   </template>
                </m-h4></template>
                </m-div></template>
                </m-a></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="content-card-wrapper-almas" >
                <template #default>   <m-a v-bind='{...{"href":"{\"name\":\"mhafezjan50\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"border-radius:15px;\ntransition: all 0.2s ease-in-out;\nbackground:#f7edff"' class="col-12 text-center p-3 shadow card-header" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.teslaelectric.ir\/storage\/products\/tT6YbaSaJE7Fz5UKQN9C9c4kkuS3lEsHH2yeURqx.jpg","alt":"clinicyas"},...{}}' :style='"border-radius:15px;\naspect-ratio:1\/1;\nobject-fit:contain;\nheight:100px\n"' class="img-fluid mb-4" ></m-img><m-h4 v-bind='{...{},...{}}' :style='"\n\n"' class="text-primary h6" >
                <template #default>محافظ ولتاژ TSE مدل تسلا سری TVP-50
   </template>
                </m-h4></template>
                </m-div></template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-modal-501></template>
                </m-div></template>
                </m-single-product-201>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleProduct201 from '@moeinmdn/miw-alpha-components/src/package/Product/Single/SingleProduct201'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5'; import mModal501 from '@moeinmdn/miw-alpha-components/src/package/Tool/Modal/Modal501'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleProduct201,mDiv,mH5,mModal501,mA,mImg,mH4 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
